<template>
	<fieldset class="talentics-fieldset">
		<legend>{{ $t('text.checkboxes') }}</legend>
		<v-container style="padding-top: 0">
			<Draggable v-model="checkboxItems" @end="$emit('input', checkboxItems)">
				<v-row
					v-for="(item, index) in checkboxItems"
					:key="`checkboxItem_${index}`"
				>
					<v-col cols="auto" align-self="center">
						<span class="all-scroll">
							<v-icon>drag_indicator</v-icon>
						</span>
					</v-col>
					<v-col align-self="center">
						<v-text-field
							v-model="item.label"
							outlined
							hide-details
							dense
							:placeholder="$t('label.checkbox-label')"
							@input="$emit('input', checkboxItems)"
							style="margin-bottom: 0.5rem"
						/>
						<RichEditor
							v-model="item.html"
							:refName="`checkbox_${index}`"
							@input="$emit('input', checkboxItems)"
						/>
					</v-col>
					<v-col cols="auto" align-self="center" class="pl-0">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									text
									icon
									v-bind="attrs"
									v-on="on"
									@click="toggleRequired(index)"
								>
									<v-icon :color="item.required ? '' : 'grey'">
										{{ item.required ? 'star' : 'star_outline' }}
									</v-icon>
								</v-btn>
							</template>
							<span>{{
								item.required ? $t('text.required') : $t('text.optional')
							}}</span>
						</v-tooltip>
					</v-col>
					<v-col cols="auto" align-self="center" class="pl-0">
						<v-btn text icon @click="deleteCheckbox(index)">
							<v-icon>delete</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</Draggable>
			<v-row style="margin-top: 0.5rem">
				<v-col>
					<v-btn @click="addCheckbox">
						<v-icon left>add</v-icon>
						{{ $t('button.add') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</fieldset>
</template>

<script>
import Draggable from 'vuedraggable';
import RichEditor from '@/components/shared/richEditor/RichEditor';

export default {
	name: 'CheckboxesEditor',
	components: { Draggable, RichEditor },
	props: {
		value: { type: Array, required: true, default: () => [] },
	},
	data() {
		return { checkboxItems: [] };
	},
	watch: {
		value: {
			handler(newVal, oldVal) {
				if (
					newVal &&
					(!oldVal || JSON.stringify(newVal) !== JSON.stringify(oldVal))
				) {
					this.checkboxItems = JSON.parse(JSON.stringify(newVal));
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		deleteCheckbox(index) {
			this.checkboxItems = this.checkboxItems.filter((_, i) => i !== index);
			this.$emit('input', this.checkboxItems);
		},
		addCheckbox() {
			this.checkboxItems.push({ label: '', html: '', required: true });
			this.$emit('input', this.checkboxItems);
		},
		toggleRequired(index) {
			this.checkboxItems[index].required = !this.checkboxItems[index].required;
			this.$emit('input', this.checkboxItems);
		},
	},
};
</script>
